import http from "../utils/http-common";

class AuthorizedDataService {
    getAll() {
        return http.get("/authorized");
    }

    get(id) {
        return http.get(`/authorized/${id}`);
    }

    create(data) {
        return http.post("/authorized", data);
    }

    update(id, data) {
        return http.put(`/authorized/${id}`, data);
    }

    delete(id) {
        return http.delete(`/authorized/${id}`);
    }
}

export default new AuthorizedDataService();
